module.exports = __webpack_public_path__ + "assets/img/23_197.5a3c7200.jpg";